import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import {popupComponents$} from '../../supplementary_components/store';
import {RemoveScroll} from 'react-remove-scroll';

export const PopupWrapped = styled.div`
    position: fixed;
    width:100vw;
    height:100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index:210;
    top:0;
    left:0;
    display:flex;
    justify-content:center;
    align-items:center;
`;
export const ContentWrapper = styled.div`
    border-radius:1rem;
    background: ${props => props.$customBackground ? props.$customBackground : 'var(--bg)'};
    overflow:hidden;
    ${props => props.$customWidth ? `width:${props.$customWidth};` : ''}
    ${props => props.$customMaxWidth ? `max-width:${props.$customMaxWidth};` : ''}
    ${props => props.$customMinWidth ? `min-width:${props.$customMinWidth};` : ''}
`;



export const PopupManager = ()=> {
    const [popupWindows, setPopupWindows] = useState(null); 
    // const [readyToClose, setReadyToClose] = useState(false)
    useEffect(() => {
        const sub = popupComponents$.subscribe(setPopupWindows);
        return () => sub.unsubscribe();
    }, [])

    
    // setFirstPopUpContent(someContent);
    //onClick={()=>{if(popupWindows[0].EZCloseAllowed){closePopup()}}}
    // let readyToClose = false
    if (popupWindows === null) return <></>;
    return <>
        {popupWindows.map((popup, index)=>{
            const closePopup = ()=>{
                popupComponents$.next(popupComponents$.getValue().splice(0, index));
                return true;
            }
            return <PopupWrapped key={index} data-closable={false} style={{ zIndex: 210 + index }}
                onMouseDown={(e)=>{
                    e.target.setAttribute("data-closable", true);
                    
                }} 
                onClick={(e)=>{
                    if(e.target.dataset.closable === 'true'){
                        if(popupWindows[0].EZCloseAllowed){closePopup()}
                    }
                }} 
                
            > 
                <ContentWrapper  onClick={e=>e.stopPropagation()} $customWidth={popup.customWidth} $customMaxWidth={popup.customMaxWidth} $customMinWidth={popup.customMinWidth} >
                    <RemoveScroll>
                        <popup.content closePopup={closePopup} popupData={popup.popupData} postSuccessAction={popup.postSuccessAction}/>
                    </RemoveScroll>
                </ContentWrapper>
            </PopupWrapped>
        })}
    </>

} 